(function () {
    if (!window.bootstrap) {

        let currentOpenCollapser = null

        const showEvent = new CustomEvent("show.bs.collapse", {
            bubbles: true,
            cancelable: true
        })
        const hideEvent = new CustomEvent("hide.bs.collapse", {
            bubbles: true,
            cancelable: true
        })

        document.addEventListener('click', function (event) {
            if (currentOpenCollapser) {
                const id = currentOpenCollapser.dataset.bsTarget // currently open
                const clickedCollapse = event.target.closest(id) // when option chosen
                const clickedButtonId = event.target.dataset.bsTarget // check if same as id

                const clickedCollapserBtn = clickedButtonId == id // So dont react
                if (!clickedCollapserBtn && !clickedCollapse) {
                    hide(currentOpenCollapser)
                }
            }
        })

        function show(element) {
            currentOpenCollapser = element

            const target = element.dataset.bsTarget
            const targetElement = target ? document.getElementById(target.substring(1)) : null
            const target2 = element.dataset.target2;
            const targetElement2 = target2 ? document.getElementById(target2.substring(1)) : null;

            if (targetElement) {
                targetElement.classList.add("show")
                element.setAttribute("aria-expanded", "true")
                element.classList.remove("collapsed")
                if (targetElement2) {
                    targetElement2.classList.add("expanded");
                }
                targetElement.dispatchEvent(showEvent)
            }
        }

        function hide(element) {
            currentOpenCollapser = null

            const target = element.dataset.bsTarget
            const targetElement = target ? document.getElementById(target.substring(1)) : null
            const target2 = element.dataset.target2;
            const targetElement2 = target2 ? document.getElementById(target2.substring(1)) : null;

            if (targetElement) {
                targetElement.classList.remove("show")
                element.setAttribute("aria-expanded", "false")
                element.classList.add("collapsed")
                targetElement.dispatchEvent(hideEvent)
                if (targetElement2) {
                    targetElement2.classList.remove("expanded");
                }
                targetElement.dispatchEvent(hideEvent)
            }
        }

        const collapsers = document.querySelectorAll('[data-bs-toggle="collapse"]');
        if (collapsers) {
            collapsers.forEach((element) => {
                document.addEventListener('keydown', function (event) {
                    if (!window.bootstrap) {
                        if (event.key === 'Escape') {
                            hide(element)
                        }
                    }
                });
                element.onclick = function (e) {
                    // use timeout to ensure this happens after the document click code above
                    setTimeout(() => {
                        e.preventDefault()
                        const expanded = element.getAttribute("aria-expanded") == "true"
                        //console.log("clicked on a collapser", element, !expanded)

                        if (!expanded) {
                            show(element)
                        } else {
                            hide(element)
                        }
                    }, 20)
                }

            })
        }
    }
})();